import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function OldSolutionsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section className="w-full bg-warm-alt py-16 md:py-24" ref={ref} data-id="element-153">
      <div className="max-w-prose mx-auto px-5" data-id="element-154">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} data-id="element-155">
          <p className="font-sans text-xs tracking-[0.15em] uppercase text-sage mb-4" data-id="element-156">
            La gran razón
          </p>

          <h2 className="font-sans font-bold text-2xl md:text-3xl text-charcoal mb-8 leading-tight" data-id="element-157">
            Por qué lo que intentaste no funcionó
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="font-serif text-lg md:text-xl leading-[1.85] text-charcoal/90 space-y-6" data-id="element-158">
          <p data-id="element-159">
            Porque la mayoría de planes se enfocan en <strong data-id="element-160">calorías</strong>{' '}
            o <strong data-id="element-161">voluntad</strong>.
          </p>

          <p data-id="element-162">
            Pero tú no necesitas más reglas imposibles. Necesitas una cosa mucho
            más práctica:
          </p>

          <p className="text-xl md:text-2xl font-semibold text-terracotta leading-snug py-2" data-id="element-163">
            Necesitas ver qué te dispara la hinchazón.
          </p>

          <p data-id="element-164">
            El problema es que casi nadie te enseña a detectarlo sin volverte
            obsesiva. Entonces cambias mil variables a la vez:
          </p>

          {/* Failed attempts */}
          <div className="bg-cream/60 rounded-xl p-6 md:p-8 border border-terracotta/15 my-4" data-id="element-165">
            <div className="grid grid-cols-2 gap-3 font-sans text-base text-charcoal/70" data-id="element-166">
              <p className="flex items-center gap-2" data-id="element-167">
                <span className="text-terracotta/50" data-id="element-168">✕</span> un día keto
              </p>
              <p className="flex items-center gap-2" data-id="element-169">
                <span className="text-terracotta/50" data-id="element-170">✕</span> otro día ayuno
              </p>
              <p className="flex items-center gap-2" data-id="element-171">
                <span className="text-terracotta/50" data-id="element-172">✕</span> otro día smoothies
              </p>
              <p className="flex items-center gap-2" data-id="element-173">
                <span className="text-terracotta/50" data-id="element-174">✕</span> ensalada gigante
              </p>
              <p className="flex items-center gap-2" data-id="element-175">
                <span className="text-terracotta/50" data-id="element-176">✕</span> suplementos
              </p>
              <p className="flex items-center gap-2" data-id="element-177">
                <span className="text-terracotta/50" data-id="element-178">✕</span> entrenos duros…
              </p>
            </div>
          </div>

          <p data-id="element-179">
            Y al final no aprendes nada.{' '}
            <strong data-id="element-180">Solo te quedas más cansada.</strong>
          </p>
        </motion.div>
      </div>
    </section>;
}